<template>
    <div>
        <NavLight/>
        <section class="relative flex items-center w-full py-36 lg:h-screen bg-gray-900 dark:bg-slate-800 bg-center bg-no-repeat bg-cover" :style="{'background-image' : 'url('+ require('../assets/images/bg/bg2.png') +')'}" id="home">
            <div class="container relative">
                <div class="grid lg:grid-cols-12 md:grid-cols-2 mt-10 items-center gap-[30px]">
                    <div class="lg:col-span-7">
                        <h4 class="font-semibold lg:leading-normal leading-normal tracking-wide text-4xl lg:text-5xl capitalize text-white mb-5">{{ $t('index.1') }}</h4>
                
                        <p class="text-white/70 text-lg max-w-xl">{{ $t('index.2') }}</p>
                    
                        <div class="relative mt-6">
                            <a href="#about" class="h-10 px-6 tracking-wide inline-flex items-center justify-center font-medium rounded-md bg-teal-500 text-white">{{ $t('index.3') }}</a>
                        </div>
                    </div>

                    <div class="lg:col-span-5">
                    </div>
                </div>
            </div><!--end container-->
        </section>
        <About/>
        <Features/>
        <AgencyTab/>
        <Client/>
        <GetInTouch/>
    </div>
</template>

<script>
import NavLight from '@/components/NavLight.vue'
import About from '@/components/About.vue'
import Features from '@/components/Features.vue'
import AgencyTab from '@/components/AgencyTab.vue'
import Client from '@/components/Client.vue'
import GetInTouch from '@/components/GetInTouch.vue'

export default {
    components:{
        NavLight,
        About,
        Features,
        AgencyTab,
        Client,
        GetInTouch
    }
}


</script>
